import AppPointDeltaBase from '@/components/AppPoint/DeltaBaseH5';
import IRAFooter from '@/components/IRAComp/IRAFooterNew';
import OtherList from '@/components/ProductCommon/OtherList';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal, { PlayerType } from '@/components/UI/EFVideoModal';
import Image from '@/components/UI/Image';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';
import { SHOW_APP_POINT_SITES } from '@/constants';
import { getDetaileMoreProducts, intlNumber } from '@/utils';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { ReactNode } from 'react';
import Capacity from './components/capacity';
import Charge from './components/charge';
import OverView from './components/OverView';
import UseTime from './components/useTime';
import css from './deltamax.module.scss';
export default function Deltamax() {
    const { Link, useState, gloproductlist, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta_max_static');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const appRedirct = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp'];
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const webpUrl = '/media/deltamax/h5/';
    const { EFPic } = createEFPic(webpUrl);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/uyB6HaquXvo',
        cn: {
            SD: 'https://videos.ecoflow.com/62db14750ce449a8a90b8e0a51385827/5530f493decb434cacbcc7a7e95e28bc-d7aa9a629894d1edaa7bb7930a3cd1db-fd.mp4',
            HD: 'https://videos.ecoflow.com/62db14750ce449a8a90b8e0a51385827/5530f493decb434cacbcc7a7e95e28bc-253b03881f702b615d0ffc2c7cc97e92-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/23eca575-182edca7b98-0004-9c91-e6d-40030.mp4',
        },
    };
    const product: any = {
        us: ['product_ps_delta_delta_mini', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_pro'],
        cn: ['product_ps_delta_delta_2', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_pro'],
        za: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_pro', 'product_ps_river_river_pro_720'],
        cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
        eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        br: ['product_ps_delta_delta_2', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_pro_plus'],
    };

    const applicationsUseTime: any = [
        {
            key: 0,
            title: t('HB'),
            content: [
                {
                    icon: ['light-icon.webp', 'light-icon.png'],
                    device: 'Light',
                    usageTime: [{ time: 189, unit: t('Hrs') }],
                },
                {
                    icon: ['refrigerator-icon.webp', 'refrigerator-icon.png'],
                    device: 'Refrigerator',
                    usageTime: [{ time: 14, unit: t('Hrs') }],
                },
                {
                    icon: ['microwave-icon.webp', 'microwave-icon.png'],
                    device: 'Microwave',
                    usageTime: [{ time: intlNumber(locale, 1.5), unit: t('Hrs') }],
                },
                {
                    icon: ['50tv-icon.webp', '50tv-icon.png'],
                    device: '50" TV',
                    usageTime: [{ time: 15, unit: t('Hrs') }],
                },
                {
                    icon: ['hair-dryer-icon.webp', 'hair-dryer-icon.png'],
                    device: 'Hair Dryer',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
                {
                    icon: ['coffee-maker-icon.webp', 'coffee-maker-icon.png'],
                    device: 'Coffee Maker',
                    usageTime: [{ time: intlNumber(locale, 1.9), unit: t('Hrs') }],
                },
                {
                    icon: ['washer-icon.webp', 'washer-icon.png'],
                    device: 'Washer',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: t('Hrs') }],
                },
                {
                    icon: ['electric-frying-pan-icon.webp', 'electric-frying-pan-icon.png'],
                    device: 'Electric Frying Pan',
                    usageTime: [{ time: intlNumber(locale, 1.6), unit: t('Hrs') }],
                },
                {
                    icon: undefined,
                    device: '',
                    usageTime: [],
                },
            ],
        },
        {
            key: 1,
            title: t('OGL'),
            content: [
                {
                    icon: ['phone-icon.webp', 'phone-icon.png'],
                    device: 'Phone',
                    usageTime: [{ time: 175, unit: t('Times') }],
                },
                {
                    icon: ['laptop-icon.webp', 'laptop-icon.png'],
                    device: 'Laptop',
                    usageTime: [{ time: 32, unit: t('Times') }],
                },
                {
                    icon: ['camera-icon.webp', 'camera-icon.png'],
                    device: 'Camera',
                    usageTime: [{ time: 118, unit: t('Times') }],
                },
                {
                    icon: ['drone-icon.webp', 'drone-icon.png'],
                    device: 'Drone',
                    usageTime: [{ time: 48, unit: t('Times') }],
                },
                {
                    icon: ['speaker-icon.webp', 'speaker-icon.png'],
                    device: 'Speaker',
                    usageTime: [{ time: 60, unit: t('Hrs') }],
                },
                {
                    icon: ['blender-icon.webp', 'blender-icon.png'],
                    device: 'Blender',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: t('Hrs') }],
                },
                {
                    icon: ['car-fridge-icon.webp', 'car-fridge-icon.png'],
                    device: 'Car Fridge',
                    usageTime: [{ time: 33, unit: t('Hrs') }],
                },
                {
                    icon: ['projector-icon.webp', 'projector-icon.png'],
                    device: 'Projector',
                    usageTime: [{ time: 24, unit: t('Hrs') }],
                },
                {
                    icon: ['ps5-icon.webp', 'ps5-icon.png'],
                    device: 'PS5',
                    usageTime: [{ time: 9, unit: t('Hrs') }],
                },
            ],
        },
        {
            key: 2,
            title: t('Professional'),
            content: [
                {
                    icon: ['circular-saw-icon.webp', 'circular-saw-icon.png'],
                    device: 'Circular Saw',
                    usageTime: [{ time: intlNumber(locale, 1.3), unit: t('Hrs') }],
                },
                {
                    icon: ['air-conditioner-icon.webp', 'air-conditioner-icon.png'],
                    device: 'Air Conditioner',
                    usageTime: [{ time: 1, unit: locale === 'de' ? t('OneHrs') : t('Hrs') }],
                },
                {
                    icon: ['electric-hammer-icon.webp', 'electric-hammer-icon.png'],
                    device: 'Electric Hammer',
                    usageTime: [{ time: intlNumber(locale, 1.5), unit: t('Hrs') }],
                },
                {
                    icon: ['electric-drill-icon.webp', 'electric-drill-icon.png'],
                    device: 'Electric Drill',
                    usageTime: [{ time: intlNumber(locale, 1.8), unit: t('Hrs') }],
                },
                {
                    icon: ['cutting-machine-icon.webp', 'cutting-machine-icon.png'],
                    device: 'Cutting Machine',
                    usageTime: [{ time: intlNumber(locale, 1.7), unit: t('Hrs') }],
                },
                {
                    icon: ['electric-oven-icon.webp', 'electric-oven-icon.png'],
                    device: 'Electric Oven',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
                {
                    icon: ['electric-grill-icon.webp', 'electric-grill-icon.png'],
                    device: 'Electric Grill',
                    usageTime: [{ time: intlNumber(locale, 1.7), unit: t('Hrs') }],
                },
                {
                    icon: ['air-fryer-icon.webp', 'air-fryer-icon.png'],
                    device: 'Air Fryer',
                    usageTime: [{ time: intlNumber(locale, 1.2), unit: t('Hrs') }],
                },
                {},
            ],
        },
    ];

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA Max',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <>
            <div className={`${css.deltamaxWrapper} deltamax_wrapper`}>
                <div className="prd-video">
                    <div className="content">
                        <div className="title">{t('banner_title_h5')}</div>
                        <div className="subtitle">{t('bannner_desc_h5')}</div>
                        <div className="videoButton" onClick={() => playerVideo('Product Detail_1')}>
                            <span className="btnText font-family-medium">{t('watch_video')}</span>
                            <span className="img-icon">
                                <Image src="/icons/video_play_white.svg" layout="fill" alt={t('watch_video')} />
                            </span>
                        </div>
                    </div>
                    <div className="img-wrapper">
                        <EFPic name={['product1.webp', 'product1.png']} alt={t('DELTA Max')} />
                    </div>
                </div>
                {/* 新版本一图看懂 */}
                <OverView />
                <div className="capacity-wrapper">
                    <Capacity />
                </div>
                <div className="fast-charge-wrapper">
                    <div className="title">
                        <div className="text">{t('Fast')}</div>
                        <div className="icon-wrapper">
                            <EFPic name={['fast-charge-icon.webp', 'fast-charge-icon.png']} alt={t('fast charging')} />
                        </div>
                        <div className="text">{t('Charging')}</div>
                    </div>
                    <div className="img-wrapper1">
                        <div className="content">
                            <div className="pretitle">{t('Up to')}</div>
                            <div className="title">{t('3600W')}</div>
                        </div>
                        <Image src="/media/deltamax/h5/fast-charge2.svg" layout="fill" alt={t('fast charging')} />
                    </div>
                </div>
                <div className="charge-wrapper">
                    <Charge />
                </div>
                <div className="ac-output">
                    <div className="content">
                        <div className="pretitle">{t('AC Output')}</div>
                        <div className="title">{t('AC_Output_value')}</div>
                    </div>
                </div>
                <div className="power-appliance">
                    <div className="content">
                        {t.rich('PA', {
                            line1: (child: ReactNode) => <div className="pretitle"> {child}</div>,
                            line2: (child: ReactNode) => <div className="title">{child}</div>,
                            line3: (child: ReactNode) => <p className="aftertitle">{child}</p>,
                        })}
                        <p className="subtitle">
                            {t.rich('PA_desc', {
                                line1: (text: string) => (
                                    <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </p>
                    </div>
                    <div className="img-wrapper">
                        <EFPic name={['ac-output.webp', 'ac-output.jpg']} alt={t('ac output')} />
                    </div>
                </div>
                <div className="application-wrapper">
                    <UseTime className="121aaa" timeList={applicationsUseTime} webpUrl={'/media/deltamax/h5/usetime/'} />
                </div>
                <div className="plugin-power">
                    {t.rich('PO', {
                        line1: (child: ReactNode) => <div className="subtitle">{child}</div>,
                        line2: (child: ReactNode) => <div className="title">{child}</div>,
                    })}
                </div>
                <div className="harness">
                    <div className="content">
                        <p className="beftitle">{t('SP')}</p>
                        <div className="title">
                            {t.rich('SP_desc', {
                                line1: (child: ReactNode) => <span className="font-yellow">{child}</span>,
                            })}
                        </div>
                        <p className="subtitle">{t('SP_notice')}</p>
                        {locale === 'cn' && <p className="hard-memo">{t('useTime_memo')}</p>}
                        <Link href={'/400w-solar-panel'} ariaLabel={s('400W Solar Panel')}>
                            <p className="des" style={{ color: '#478fff' }}>
                                {s('for_blind.learn_more')}
                                <span className="imgs">
                                    <EFArrowRightBlueSmall />
                                </span>
                            </p>
                        </Link>
                    </div>
                    <div className="img-wrapper">
                        <EFPic name={['harness.webp', 'harness.png']} alt={t('Up to 800W of Solar Power')} />
                    </div>
                </div>
                <div className="power-up">
                    <div className="content">
                        <p className="beftitle">{t('SG')}</p>
                        <div className="title">{t('SG_title')}</div>
                        <p className="subtitle">{t('SG_desc')} </p>
                        <p className="tips">{t('SG_notice')}</p>
                        {!['cis', 'tw', 'kr'].includes(locale) && (
                            <Link href={['us', 'ca'].includes(locale) ? '/dual-fuel-smart-generator' : '/smart-generator'} ariaLabel={t('Smart Generator')}>
                                <p className="des" style={{ color: '#478fff' }}>
                                    {s('for_blind.learn_more')}
                                    <span className="imgs">
                                        <EFArrowRightBlueSmall />
                                    </span>
                                </p>
                            </Link>
                        )}
                    </div>
                    <div className="img-wrapper">
                        <EFPic name={['power-up.webp', 'power-up.png']} alt={t('Smart Generator')} />
                    </div>
                </div>
                {!SHOW_APP_POINT_SITES.includes(locale) && (
                    <div className="real-time">
                        <div className="content">
                            <p className="beftitle">{t('EA')}</p>
                            <div className="title">
                                {t.rich('EA_title', {
                                    line1: (child: ReactNode) => <span className="font-orange">{child}</span>,
                                })}
                            </div>
                            <p className="subtitle">{t('EA_desc')}</p>
                            {appRedirct.includes(locale) && (
                                <Link href="/app" className="link_learn" newWin>
                                    <div className="text2">{t('learn_more')}</div>
                                    <div className="icon">
                                        <EFAppArrow />
                                    </div>
                                </Link>
                            )}
                        </div>
                        <div className="img-wrapper">
                            <EFPic name={[`real-time_${appImgLocal}.webp`, `real-time_${appImgLocal}.jpg`]} alt={t('EcoFlow App')} />
                        </div>
                        <p className="tips">{t('EA_notice')}</p>
                    </div>
                )}
                {SHOW_APP_POINT_SITES.includes(locale) && <AppPointDeltaBase />}
                <div className="multiple-levels">
                    <div className="content">
                        <p className="beftitle">{t('BMS')}</p>
                        <div className="title">
                            {t.rich('BMS_title', {
                                line1: (child: ReactNode) => <span className="font-green"> {child}</span>,
                            })}
                        </div>
                        <p className="subtitle">{t('BMS_desc')}</p>
                    </div>
                    <div className="video-wrapper">
                        <EFVideo className="video" sources={['/video/deltamax-h5/max-bms.webm', '/video/deltamax-h5/max-bms.mp4']} />
                    </div>
                </div>
                <div className="interior-desig">
                    <div className="content">
                        <div className="title">{t('Interior Design')}</div>
                        <p className="subtitle">{t('ID_desc')} </p>
                    </div>
                    <EFPic className="pic-style" name={['interior-design.webp', 'interior-design.jpg']} alt={t('Interior Design')} />
                </div>
                <div className="rubber-fire">
                    <div className="rubber-anti item">
                        <div className="content">
                            <div className="title">{t('RB')}</div>
                        </div>
                        <EFPic className="pic-style" name={['rubber-anti-slip-bas.webp', 'rubber-anti-slip-bas.png']} alt={t('delta_max_rubber')} />
                    </div>
                    <div className="item fire-resistant">
                        <div className="content">
                            <div className="title">{t('FS')}</div>
                        </div>
                        <EFPic className="pic-style" name={['fire-resistant-shell.webp', 'fire-resistant-shell.png']} alt={t('delta_max_shell')} />
                    </div>
                </div>

                <div className="exterior-design">
                    <div className="content">
                        <div className="title">{t('ED')}</div>
                        <p className="subtitle">{t('ED_desc')}</p>
                    </div>
                    <EFPic className="pic-style" name={['exteriordesign.webp', 'exteriordesign.png']} alt={t('delta_max')} />
                </div>
                {locale === 'us' && <IRAFooter borderTopColor="transparent" />}
                <OtherList theme="black" data={getDetaileMoreProducts(gloproductlist, product[locale] || product.us)} />
                <EFVideoModal
                    visible={showEFVideoModal}
                    source={videoSourceMap[locale] || videoSourceMap.us}
                    onClose={() => setShowEFVideoModal(false)}
                    playerType={locale === 'cn' ? PlayerType.Alibaba : PlayerType.YouTube}
                />
            </div>
        </>
    );
}
